import React from 'react';
import { Box, Pagination, Skeleton, Typography } from '@mui/material';
import { DataCell, DataRow } from '../Tables/DataList';

/**
 * Skeleton placeholder rows shown while a tab's page is loading.
 * `columns` is the list of `xs` spans (matching the tab's real columns).
 */
export function TabSkeletonRows(props: { rows: number; columns: number[] }) {
  const { rows, columns } = props;
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <DataRow key={`skeleton-${rowIndex}`}>
          {columns.map((xs, columnIndex) => (
            <DataCell key={columnIndex} xs={xs}>
              <Skeleton variant='text' />
            </DataCell>
          ))}
        </DataRow>
      ))}
    </>
  );
}

export function TabEmpty(props: { label?: string }) {
  return (
    <Box sx={{ py: 4, textAlign: 'center' }}>
      <Typography variant='body2' color='text.secondary'>{props.label ?? 'No records'}</Typography>
    </Box>
  );
}

const paginationSx = {
  '& .MuiPaginationItem-root': {
    color: '#666',
    fontWeight: 500,
  },
  '& .MuiPaginationItem-root.Mui-selected': {
    backgroundColor: '#1976d2',
    color: '#fff',
    fontWeight: 600,
    '&:hover': { backgroundColor: '#135ea7' },
  },
};

/**
 * Shared styled pagination for the company-detail tabs. Renders nothing when
 * everything fits on a single page.
 */
export function TabPagination(props: {
  count: number;
  page: number;
  pageSize: number;
  onChange: (page: number) => void;
}) {
  const { count, page, pageSize, onChange } = props;
  if (count <= pageSize) return null;

  const totalPages = Math.max(1, Math.ceil(count / pageSize));
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', pt: 2 }}>
      <Pagination
        count={totalPages}
        page={page}
        onChange={(_, value) => onChange(value)}
        showFirstButton
        showLastButton
        shape='circular'
        sx={paginationSx}
      />
    </Box>
  );
}
